import { render } from "./MainMore.vue?vue&type=template&id=85f68532&scoped=true"
import script from "./MainMore.vue?vue&type=script&lang=js"
export * from "./MainMore.vue?vue&type=script&lang=js"

import "./MainMore.vue?vue&type=style&index=0&id=85f68532&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f68532"]])

export default __exports__